import React, {PureComponent} from "react"
import {FormattedMessage} from "@irati/utils/lang"
import styled from "styled-components"

const StyledSpan = styled.span`
  word-break: break-word;
`

interface Props {
  message: string,
  isModerated: boolean
}

export default class ModeratedMessage extends PureComponent<Props> {
  render() {
    const {message, isModerated} = this.props

    if (isModerated) {
      return <FormattedMessage id="recognition.moderation.replacement" />
    }

    return <StyledSpan>{message}</StyledSpan>
  }
}
